var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"c-cbr-Header"},[(_vm.stage !== 'prod')?_c('span',{class:[_vm.$style.stageClass, _vm.$style[_vm.stage]]},[_vm._v("["+_vm._s(_vm.stage)+"]")]):_vm._e(),_vm._v(" "),_vm._t("logo",[_c('cbr-logo',{attrs:{"src":_vm.logo,"position":"left"}})]),_vm._v(" "),_vm._t("navigation",[_c('cbr-navigation')])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43e91c8e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/CbrHeader.vue
// module id = 213
// module chunks = 0